import { Slide } from "react-reveal";
import deposit from "../../assets/images/content-icons/deposit.png";
import quote from "../../assets/images/content-icons/quote.png";
import schedule from "../../assets/images/content-icons/schedule.png";
import paint from "../../assets/images/content-icons/paint.png";

const HowWeWork = () => {
  return (
    <section className="section-spacing-80 howWe cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600 margin-auto">
              <Slide top>
                <h2 className="section-title big-title">
                  <span className="flexi-gold">How to</span> Get Your Property
                  Painted by <span className="flexi-gold">Flexi Painters</span>?
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="how-steps-container">
                <li className="how-step-card">
                  <img src={schedule} alt="Book site visit icon" />
                  <h3>Book a Site Visit</h3>
                  <p>
                    Schedule a{" "}
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      site visit
                    </a>{" "}
                    so we can assess your property
                  </p>
                </li>
                <li className="how-step-card">
                  <img src={quote} alt="Quote icon" />
                  <h3>Get a Perfect Quote</h3>
                  <p>Receive a detailed quotation and project plan</p>
                </li>
                <li className="how-step-card">
                  <img src={deposit} alt="Deposit icon" />
                  <h3>Confirm with a Deposit</h3>
                  <p>
                    This allows us to schedule the work and procure materials
                  </p>
                </li>
                <li className="how-step-card">
                  <img src={paint} alt="Paint icon" />
                  <h3>We Paint & Deliver</h3>
                  <p>
                    Our team prepares and paints your property professionally
                  </p>
                </li>
              </ul>
            </div>
            <div className="section-footer section-spacing-20">
              <div className="section-footer-cta-container center">
                <a
                  href="https://form.jotform.com/flexipainters/book-site-visit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button section-main-cta"
                >
                  Book Site Visit
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
